// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AudioOutlinedSvg from "@fishx/icons-svg/es/asn/AudioOutlined";
import FishxIcon from '../components/FishxIcon';

var AudioOutlined = function AudioOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AudioOutlinedSvg
  }));
};

AudioOutlined.displayName = 'AudioOutlined';
export default React.forwardRef(AudioOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AudioOutlined.js
// module id = 2029
// module chunks = 0